export class Mail {
  constructor() {
    this.decryptEmail();
  }

  private decryptEmail(): void {
    document.querySelectorAll('a').forEach((element) => {
      if (element.href.includes('mailto:')) {
        const item = element.href.replace('mailto:', '');
        const body = { content: item };

        element.addEventListener('click', (event) => {
          event.preventDefault();

          fetch('/ajax/decrypt/', {
            method: 'post',
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((data) => window.open('mailto:' + data['email']));
        });
      }
    });
  }
}
